var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxArrowTrendUp = function Svg18PxArrowTrendUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M1.75 13a.75.75 0 0 1-.53-1.281l3.646-3.646a1.25 1.25 0 0 1 1.768 0l3.116 3.116 5.72-5.72a.75.75 0 1 1 1.061 1.061l-5.896 5.896a1.25 1.25 0 0 1-1.768 0L5.751 9.31l-3.47 3.47a.75.75 0 0 1-.53.22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M16.25 11.5a.75.75 0 0 1-.75-.75V6.5h-4.25a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75"
  })));
};
export default Svg18PxArrowTrendUp;